import { FC } from 'react';

import { AccountSupport } from '@bpm-web-app/components/src/lib/supreme-account/support/support';
import { AccountPageProps } from '@bpm-web-app/components/src/lib/supreme-account/account';

export const SupportPage: FC<AccountPageProps> = (props) => <AccountSupport {...props} />;

export default SupportPage;

export async function getStaticProps() {
    return {
        props: {
            title: 'Support',
        },
    };
}
